import Component from '@glimmer/component';
import { service } from '@ember/service';
import { action } from '@ember/object';
import tippy from 'tippy.js';
import { tracked } from '@glimmer/tracking';

export default class OrganismsInitiativeListItemDropdownComponent extends Component {
  @service store;

  tippyInstance;
  @tracked isOpen = false;

  constructor() {
    super(...arguments);
  }

  @action
  createTippy(element) {
    let tigger = element.querySelector('.list-item-dropdown');
    let dropdown = element.querySelector('.tippy-dropdown');
    let self = this;
    this.tippyInstance = tippy(tigger, {
      content: dropdown,
      arrow: false,
      trigger: 'click',
      interactive: true,
      offset: [-24, 4],
      onShow() {
        this.is_open = true;
        if (self.args.itemSelected) {
          self.args.itemSelected(true);
        }
      },
      onHide() {
        this.is_open = false;
        if (self.args.itemSelected) {
          self.args.itemSelected(false);
        }
      },
    });
  }

  @action
  closeMenu() {
    this.tippyInstance.hide();
    this.is_open = false;
    if (this.args.itemSelected) {
      this.args.itemSelected(false);
    }
  }
}
